import { reloadOnceForChunkError, isChunkLoadError } from './chunkLoadRecovery';

/**
 * React.lazy wrapper that recovers from stale chunk references after deployment.
 * If the chunk is missing (old tab + new hashed files), we reload once.
 */
export const lazyRetry = <T extends React.ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
): Promise<{ default: T }> => {
  return importFn().catch((error) => {
    if (isChunkLoadError(error)) {
      const didReload = reloadOnceForChunkError();
      if (didReload) {
        // Keep Suspense pending while reload is in progress.
        return new Promise<never>(() => {});
      }
    }
    throw error;
  });
};
